import {
  CruiseControlType,
  FacialType,
  GameSettingType,
  WalkStyle,
} from "@1games-ru/region-shared/dist/enums/account/settings";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/core/store";

export interface GameplaySettings {
  [GameSettingType.SettingWalkStyleType]: WalkStyle;
  [GameSettingType.SettingCruiseControlType]: CruiseControlType;
  [GameSettingType.SettingFacialEmotionsType]: FacialType;
  [GameSettingType.SettingVehicleEnterType]: number;
}

export interface GameplaySettingsState {
  appliedSettings: GameplaySettings | null;
  memoizedSettings: GameplaySettings | null;
}

const initialState: GameplaySettingsState = {
  appliedSettings: null,
  memoizedSettings: null,
};

const gameplaySettingsSlice = createSlice({
  name: "gameplaySettings",
  initialState,
  reducers: {
    setAppliedSettings: (state, action: PayloadAction<Partial<GameplaySettingsState>>) => {
      state.appliedSettings = { ...state.appliedSettings, ...action.payload };
    },
    setMemoizedSettings: (state, action: PayloadAction<Partial<GameplaySettingsState> | null>) => {
      if (action.payload) {
        state.memoizedSettings = { ...state.memoizedSettings, ...action.payload };
      } else {
        state.memoizedSettings = null;
      }
    },
    reset: (state) => {
      state.appliedSettings = { ...state.memoizedSettings };
    },
  },
});

export const gameplaySettingsSelector = (state: RootState) => state.gameplaySettings;
export const appliedGameplaySettingsSelector = (state: RootState) =>
  state.gameplaySettings.appliedSettings;
export const memoizedGameplaySettingsSelector = (state: RootState) =>
  state.gameplaySettings.memoizedSettings;

export const gameplaySettingsReducer = gameplaySettingsSlice.reducer;

export const { setAppliedSettings, setMemoizedSettings, reset } = gameplaySettingsSlice.actions;
